export const ADD_CHARACTER_FAVORITE = 'ADD_CHARACTER_FAVORITE',
      REMOVE_CHARACTER_FAVORITE = 'REMOVE_CHARACTER_FAVORITE',
      ADD_NUMBERS_PAGES_PAGINATOR = 'ADD_NUMBERS_PAGES_PAGINATOR';